import axios from "axios";
import { apiRoot } from "../../apiRoot";
import {
  UPDATE_MODAL_ACTION_TYPE,
  UPDATES_ALL_ACTION_TYPE,
} from "../actions-type";

const API = axios.create({
  baseURL: `${apiRoot}/history`,
  withCredentials: true,
});
API.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

const loading = (loadingValue) => ({
  type: UPDATES_ALL_ACTION_TYPE.LOADING_UPDATES,
  payload: loadingValue,
});

export const getUpdatesAction =
  (id, modelName, groupId) => async (dispatch) => {
    dispatch(loading(true));
    try {
      const { data } = await API.get(
        `/by-docmunet-id/${id}?modelName=${modelName}&groupId=${groupId || ""}`
      );
      dispatch({
        type: UPDATES_ALL_ACTION_TYPE.GET_ALL_UPDATES,
        payload: data,
      });
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(loading(false));
    }
  };

export const changeStudentUpdatesStatusAction =
  (id, newData) => async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_MODAL_ACTION_TYPE.UPDATES_LOADING,
        payload: true,
      });
      const { data } = await API.patch(`/student/${id}`, newData);
      dispatch({
        type: UPDATES_ALL_ACTION_TYPE.CHANGE_UPDATES_STATUS,
        payload: data,
      });
      dispatch({
        type: UPDATE_MODAL_ACTION_TYPE.UPDATES_OPEN_MODAL,
        payload: false,
      });
    } catch (error) {
      console.log(error);
    } finally {
      dispatch({
        type: UPDATE_MODAL_ACTION_TYPE.UPDATES_LOADING,
        payload: false,
      });
    }
  };
